import { useState } from 'react'
import PropTypes from 'prop-types'
import { Icon } from '@iconify/react'
import { NavLink as RouterLink, matchPath, useLocation } from 'react-router-dom'
import arrowIosForwardFill from '@iconify/icons-eva/arrow-ios-forward-fill'
import arrowIosDownwardFill from '@iconify/icons-eva/arrow-ios-downward-fill'
// material
import {
  alpha,
  useTheme,
  experimentalStyled as styled,
} from '@material-ui/core/styles'
import {
  Box,
  List,
  ListItem,
  Collapse,
  ListItemText,
  ListItemIcon,
  ListSubheader,
} from '@material-ui/core'
import useAuth from 'src/hooks/useAuth'

// ----------------------------------------------------------------------

const ListSubheaderStyle = styled((props) => (
  <ListSubheader disableSticky disableGutters {...props} />
))(({ theme }) => ({
  ...theme.typography.overline,
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(2),
  paddingLeft: theme.spacing(5),
  color: theme.palette.text.primary,
}))

const ListItemStyle = styled((props) => (
  <ListItem button disableGutters {...props} />
))(({ theme }) => ({
  ...theme.typography.body2,
  height: 48,
  position: 'relative',
  textTransform: 'capitalize',
  paddingLeft: theme.spacing(5),
  paddingRight: theme.spacing(2.5),
  color: theme.palette.text.secondary,
  '&:before': {
    top: 0,
    right: 0,
    width: 3,
    bottom: 0,
    content: "''",
    display: 'none',
    position: 'absolute',
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
    backgroundColor: theme.palette.primary.main,
  },
}))

const ListItemIconStyle = styled(ListItemIcon)({
  width: 22,
  height: 22,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
  active: PropTypes.func,
}

function NavItem({ item, active }) {
  const theme = useTheme()
  const isActiveRoot = active(item.path)
  const { title, path, icon, info, children } = item
  const { user } = useAuth()
  console.log('title++++++++++++++', title)
  console.log('dddddddddddddddddddddd', user?.permission_id)
  const [open, setOpen] = useState(isActiveRoot)
  if (title === 'production control board') {
    const permissions = [101]
    if (
      !permissions?.some((perm) =>
        user?.permission_id?.split(',')?.includes(perm.toString()),
      )
    ) {
      return null
    }
  }
  if (title === 'bookings') {
    const permissions = [50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 146]
    if (
      !permissions?.some((perm) =>
        user?.permission_id?.split(',')?.includes(perm.toString()),
      )
    ) {
      return null
    }
  }
  if (title === 'users') {
    const permissions = [1, 2, 3, 4, 5, 6, 7]
    console.log('user?.permission_id', user?.permission_id)
    let data = permissions?.some((perm) =>
      user?.permission_id?.split(',')?.includes(perm.toString()),
    )
    console.log('user?.permission_id', data)
    if (
      !permissions?.some((perm) =>
        user?.permission_id?.split(',')?.includes(perm.toString()),
      )
    ) {
      return null
    }
    console.log('user?.permission_id1', user?.permission_id)
  }

  if (title === 'customers') {
    const permissions = [42, 43, 44, 45, 46, 47, 48, 49]
    if (
      !permissions?.some((perm) =>
        user?.permission_id?.split(',')?.includes(perm.toString()),
      )
    ) {
      return null
    }
  }
  if (title === 'vehicles') {
    const permissions = [27, 28, 29, 30, 31, 32, 33, 60, 16, 17, 18, 19, 20, 21, 22]
    if (
      !permissions?.some((perm) =>
        user?.permission_id?.split(',')?.includes(perm.toString()),
      )
    ) {
      return null
    }
  }
  if (title === 'trips') {
    const permissions = [34, 35, 36, 37, 38, 39, 40, 41]
    if (
      !permissions?.some((perm) =>
        user?.permission_id?.split(',')?.includes(perm.toString()),
      )
    ) {
      return null
    }
  }
  if (title === 'branches') {
    const permissions = [8, 9, 10, 11, 12, 13, 14, 15]
    if (
      !permissions?.some((perm) =>
        user?.permission_id?.split(',')?.includes(perm.toString()),
      )
    ) {
      return null
    }
  }
  if (title === 'roles') {
    const permissions = [23, 24, 25, 26]
    if (
      !permissions?.some((perm) =>
        user?.permission_id?.split(',')?.includes(perm.toString()),
      )
    ) {
      return null
    }
  }
  if (title === 'reports') {
    const permissions = [
      61, 62, 63, 64, 65, 66, 67, 68, 69, 85, 86, 87, 88, 89, 90, 91, 92, 93,
      94, 95, 96, 97, 98, 99, 100,
    ]
    if (
      !permissions?.some((perm) =>
        user?.permission_id?.split(',')?.includes(perm.toString()),
      )
    ) {
      return null
    }
  }

  const handleOpen = () => {
    setOpen((prev) => !prev)
  }

  const activeRootStyle = {
    color: 'primary.main',
    fontWeight: 'fontWeightMedium',
    bgcolor: alpha(
      theme.palette.primary.main,
      theme.palette.action.selectedOpacity,
    ),
    '&:before': { display: 'block' },
  }

  const activeSubStyle = {
    color: 'text.primary',
    fontWeight: 'fontWeightMedium',
  }

  if (children) {
    return (
      <>
        <ListItemStyle
          onClick={handleOpen}
          sx={{
            ...(isActiveRoot && activeRootStyle),
          }}
        >
          <ListItemIconStyle>{icon && icon}</ListItemIconStyle>
          <ListItemText disableTypography primary={title} />
          {info && info}
          <Box
            component={Icon}
            icon={open ? arrowIosDownwardFill : arrowIosForwardFill}
            sx={{ width: 16, height: 16, ml: 1 }}
          />
        </ListItemStyle>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {children
              .filter((child) => {
                
                console.log('aaaaaaaaaaaaaaaa',child.title )
                // Skip if hidden returns true
                if (child.hidden && child.hidden(user)) return false

                // Add permission check based on child title
                {/* const childPermissionsMap = {
                  vehicles: [27, 28, 29,30,31,32,33,60],
                  drivers: [16,17,18,19,20,21,22],
                  'booking statement reports': [61,62,63,64],
                  'booking reports': [65,66,67,68],
                  'booking summary reports':[69,85,86,87],
                  'delivery reports':[88,89,90,91],
                  'delivery summary reports':[92,93,94,95],
                  'cancelled reports':[96,97,98,99,100],
                  // add other submodule titles and permission arrays as needed
                }

                const requiredPerms =
                  childPermissionsMap[child.title?.toLowerCase()]
                if (requiredPerms && Array.isArray(requiredPerms)) {
                  return requiredPerms.some((perm) =>
                    user?.permission_id?.split(',')?.includes(perm.toString()),
                  )
                } */}

                return true // show if no permission restriction defined
              })
              .map((item) => {
                const { title, path } = item
                const isActiveSub = active(path)

                return (
                  <ListItemStyle
                    key={title}
                    component={RouterLink}
                    to={path}
                    sx={{
                      ...(isActiveSub && activeSubStyle),
                    }}
                  >
                    <ListItemIconStyle>
                      <Box
                        component="span"
                        sx={{
                          width: 4,
                          height: 4,
                          display: 'flex',
                          borderRadius: '50%',
                          alignItems: 'center',
                          justifyContent: 'center',
                          bgcolor: 'text.disabled',
                          transition: (theme) =>
                            theme.transitions.create('transform'),
                          ...(isActiveSub && {
                            transform: 'scale(2)',
                            bgcolor: 'primary.main',
                          }),
                        }}
                      />
                    </ListItemIconStyle>
                    <ListItemText disableTypography primary={title} />
                  </ListItemStyle>
                )
              })}
          </List>
        </Collapse>
      </>
    )
  }

  return (
    <ListItemStyle
      component={RouterLink}
      to={path}
      sx={{
        ...(isActiveRoot && activeRootStyle),
      }}
    >
      <ListItemIconStyle>{icon && icon}</ListItemIconStyle>
      <ListItemText disableTypography primary={title} />
      {info && info}
    </ListItemStyle>
  )
}

NavSection.propTypes = {
  navConfig: PropTypes.array,
}

export default function NavSection({ navConfig, ...other }) {
  const { pathname } = useLocation()
  const { user } = useAuth()
  const match = (path) =>
    path ? !!matchPath({ path, end: false }, pathname) : false

  return (
    <Box {...other}>
      {navConfig.map((list) => {
        const { subheader, items } = list
        const filteredItems = items.filter(
          (item) => !item.hidden || !item.hidden(user),
        )
        console.log('filteredItems++++++++++++++1', filteredItems)
        if (filteredItems.length === 0) return null

        return (
          <List key={subheader} disablePadding>
            <ListSubheaderStyle>{subheader}</ListSubheaderStyle>
            {filteredItems.map((item) => (
              <NavItem key={item.title} item={item} active={match} />
            ))}
          </List>
        )
      })}
    </Box>
  )
}